import { ValidatorFn, AbstractControl } from '@angular/forms';
import { DateTimeUtility } from 'src/shared/utility/date-time.utility';

export function OptionalDateRangeValidator(
	fromControl: AbstractControl,
	toControl: AbstractControl
): ValidatorFn {
	return (_control: AbstractControl): { [key: string]: any } | null => {
		const validFrom: boolean = DateTimeUtility.isValidDate(
			fromControl.value
		);
		const validTo: boolean = DateTimeUtility.isValidDate(toControl.value);
		const error = {
			optionalDateRange: true,
		};
		return (!validFrom && !validTo) ||
			(validFrom &&
				validTo &&
				DateTimeUtility.isValidDateRange(
					fromControl.value,
					toControl.value
				))
			? null
			: error;
	};
}
